import React from "react";
import { useLocation } from "react-router-dom";
import usePermissions from "../../../hooks/usePermissions";
import { getSideBarItems } from "./config";
import { SideNavItem } from "./side-nav-item";
import { Box, Stack } from "@mui/material";

function Navigation({ isRow = false }) {
  const { pathname } = useLocation();
  const locationUrl = pathname.split("/")[1];
  const { role, capabilities, authBypassed } = usePermissions();
  const items = React.useMemo(
    () => getSideBarItems({ role, capabilities, authBypassed }),
    [authBypassed, capabilities, role]
  );

  return (
    <Box
      component="nav"
      sx={
        isRow
          ? {}
          : {
              flexGrow: 1,
              px: 2,
              py: 3,
            }
      }
    >
      <Stack
        component={isRow ? "div" : "ul"}
        spacing={0.5}
        sx={{
          listStyle: "none",
          p: 0,
          m: 0,
          display: isRow ? "flex" : "block",
          flexDirection: isRow ? "row" : "column",
        }}
      >
        {items.map((item) => {
          const active = item.path
            ? locationUrl === item.path.replace("/", "")
            : false;

          return (
            <SideNavItem
              active={active}
              disabled={item.disabled}
              external={item.external}
              icon={item.icon}
              key={item.title}
              path={item.path}
              title={item.title}
              isRow={isRow}
            />
          );
        })}
      </Stack>
    </Box>
  );
}

export default Navigation;
